// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page_wrapper__Az8TF","main":"page_main__25yKX"};